/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetJobStatsQueryResponse, IngestionStatusControllerGetJobStatsQueryParams, IngestionStatusControllerGetJobStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetJobStats";

function getIngestionStatusControllerGetJobStatsUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/jobs` as const }  
  return res
}

/**
 * @description Returns statistics about the job processing system, including job counts by status and type, failure rates, retry rates, and recent failures. Requires System Administrator role.
 * @summary Get job system statistics
 * {@link /api/v1/documents/ingestion-status/jobs}
 */
export async function ingestionStatusControllerGetJobStats(params?: IngestionStatusControllerGetJobStatsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetJobStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetJobStats403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetJobStatsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}